import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService } from 'src/app/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'app-superadmin-form',
  templateUrl: './superadmin-form.component.html',
  styleUrls: ['./superadmin-form.component.less']
})
export class SuperadminFormComponent implements OnInit {

  superadminform = new FormGroup({});
  superadminmodel: any = {};
  superadminoptions: FormlyFormOptions = {};
  superadminfields: FormlyFieldConfig[] = [
  ];
  constructor(private _translateService: TranslateService,
    private _ajaxService: AjaxService,
    private _formValidationService: FormValidationService,
    private _confirmationService: ConfirmationService,
    private _dataService: CommonDataService,
    private location: Location,
    private _router: Router) { }

  ngOnInit(): void {
    this.createSuperAdminForm();
    this._dataService.getUserDetails().subscribe(result => {
      const data = result.data;
      console.log(data);
      this.superadminmodel = { ...data.Admin };
    });
  }

  get isEditAccountPage() {
    return this._router.url.indexOf('edit-information') !== -1;
  }



  createSuperAdminForm() {
    this.superadminfields = [
      {
        key: 'Salutation',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            { label: 'MR', value: 'MR' },
            { label: 'MRS', value: 'MRS' },
            { label: 'MS.', value: 'MS.' },
            { label: 'Dr', value: 'Dr' },
            { label: 'Other', value: 'Other' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSalutation'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'FirstName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblFirstName'),
        }
      },
      {
        key: 'LastName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblLastName'),
        }
      },
      {
        key: 'Email',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmail'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'MobileNo',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMobileNo'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'Address',
        type: 'textarea',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAddress'),
        }
      },
      {
        key: 'Role',
        hideExpression: () => this.isEditAccountPage,
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [{
            label: 'Admin', value: '/super-admin/createAdmin'
          }, {
            label: 'Consultant', value: '/super-admin/createConsultant'
          }, {
            label: 'Clinician', value: '/super-admin/createClinician'
          }]
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblRole'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      }
    ];
  }

  registerClicked() {
    const value = { ...this.superadminmodel };
    console.log(value);
    this._formValidationService.markFormGroupTouched(this.superadminform);
    if (this.superadminform.valid) {
      this._ajaxService.post('/super-admin/create',value).subscribe((response) => {
        const result = response.data;
        console.log(value);
        if (response.success) {
          this._confirmationService.confirm({
            message: (this.isEditAccountPage) ? this._translateService.instant('LblSuperAdminUpdated') : this._translateService.instant('LblSuperAdminRegistered'),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              if (!this.isEditAccountPage) {
                this.superadminform.reset();
              } else {
                this.superadminmodel = {
                  ...result
                }
                this.location.back();
              }
              //Actual logic to perform a confirmation
            }
          });
        }
      });
    }
  }

  cancelClicked() {
    this.location.back();
  }

}
